import { Mapper } from '../../../common/ddd/mapper.base';
import { GetAccountMetricsInsightChartDataResponse } from '../../../interface/dtos/challenge-insights/get-account-metrics-insight-digital-working-hours-chart-data.response.dto';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { ChallengeTimeInCallsEntity } from '../../../core/domain/entities/challenge-insights/challenge-time-in-calls.entity';
import { MetricValueType } from '../../../interface/dtos';

export class ChallengeTimeInCallsChartDataMapper
  implements
    Omit<
      Mapper<
        ChallengeTimeInCallsEntity,
        GetAccountMetricsInsightChartDataResponse
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeTimeInCallsEntity
  ): GetAccountMetricsInsightChartDataResponse {
    return ChallengeTimeInCallsChartDataMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeTimeInCallsEntity
  ): GetAccountMetricsInsightChartDataResponse {
    return {
      totalValue: entity.value === null ? null : entity.value,
      formattedTotalValue:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.value))
          : formatDuration(entity.value),
      value: entity.value === null ? null : entity.average,
      formattedValue:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.average))
          : formatDuration(entity.average),
      date: entity.date.toISOString().split('T')[0],
      uniqueUserCount: entity.userCount,
    };
  }
}
